import * as React from "react";
import {Box, Chip, Typography} from "@mui/material";
import {CommonIconButton} from "../../@components";

import { DAYS_OF_WEEK, MONTHS } from "../../constants";


export default function executionsColumn() {
    return {
        name: "executions",
        label: "Executions",
        options: {
            filter: false,
            setCellProps: () => ({ sx: { maxWidth: 300 } }),
            customBodyRowRenderLite: (value, row) => {

                const timeToShow = value['Time'].slice(0,4)
                const monthsDaysToShow = value['Months Days'].slice(0,3)
                const monthsToShow = value['Months'].slice(0,3)
                const weekdaysToShow = value['Week Days'].slice(0,3)

                return <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography component="span" fontWeight="bold" sx={{ mr: 2 }}>Zone:</Typography>
                        <Typography variant="body2">{row.zone}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography component="span" fontWeight="bold" sx={{ mr: 2 }}>Time:</Typography>
                        {timeToShow.map((hours, index) => (
                            <Chip
                                label={new Date(hours).toLocaleTimeString()}
                                key={index}
                                sx={{ mr: 1, backgroundColor: "disabled.dark" }}
                            />
                        ))}
                        { value['Time']?.length > 4 && <CommonIconButton remaining={value['Time']?.length - 4} />}
                    </Box>

                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography component="span" fontWeight="bold" sx={{ mr: 2 }}>Months Days:</Typography>
                        {!value["Months Days"]?.length ? (
                            <Typography variant="body2">All</Typography>
                        ) : (
                            monthsDaysToShow.map((day, index) => (
                                <Chip
                                    label={day}
                                    key={index}
                                    sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                                />
                            ))
                        )}
                        { value['Months Days']?.length > 3 && <CommonIconButton remaining={value['Months Days']?.length - 3} />}
                    </Box>

                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography component="span" fontWeight="bold" sx={{ mr: 2 }}>Months:</Typography>
                        {!value["Months"]?.length ? (
                            <Typography variant="body2">All</Typography>
                        ) : (
                            monthsToShow.map((month, index) => (
                                <Chip
                                    label={MONTHS[month + 1]}
                                    key={index}
                                    sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                                />
                            ))
                        )}
                        { value['Months']?.length > 3 && <CommonIconButton remaining={value['Months']?.length - 3} />}
                    </Box>

                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography component="span" fontWeight="bold" sx={{ mr: 2 }}>Week Days:</Typography>
                        {!value["Week Days"]?.length ? (
                            <Typography variant="body2">All</Typography>
                        ) : (
                            weekdaysToShow.map((day, index) => (
                                <Chip
                                    label={DAYS_OF_WEEK[day]}
                                    key={index}
                                    sx={{ mr: 1, mt: 1, backgroundColor: "disabled.dark" }}
                                />
                            ))
                        )}
                        { value['Week Days']?.length > 3 && <CommonIconButton remaining={value['Week Days']?.length - 3} />}
                    </Box>

                </Box>
            }
        }
    };
}
